import styles from "@shared/components/chat/Messages.module.scss"

import React, { memo } from "react"

import { ChatDownIcon, PowerfulMessage } from "@shared/components"
import { useLayerPopupContext, useMessagesContext } from "@shared/contexts"
import { useCheckNewMessage, useMessagesRef } from "@shared/hooks"

import classNames from "classnames"

interface Props {
  isActive: boolean
}

function PartnerMessages({ isActive }: Props) {
  const { font } = useLayerPopupContext()
  const { messages: partnerMessages } = useMessagesContext()

  const { messagesRef } = useMessagesRef({
    messages: partnerMessages,
  })

  useCheckNewMessage({
    messages: partnerMessages,
    isActive,
    isUser: false,
    isPartner: true,
  })

  return (
    <>
      <div className={`chatB ${isActive ? styles.active : styles.hidden}`}>
        <div
          className={classNames("inner", styles[font.size])}
          ref={messagesRef}
        >
          {partnerMessages.map((message) => (
            <PowerfulMessage key={message.key} message={message} />
          ))}
          <ChatDownIcon messagesRef={messagesRef} />
        </div>
      </div>
    </>
  )
}

export default memo(PartnerMessages)
